/**
 * Cross-link list for the San Antonio product landing pages.
 * Each entry is rendered as a sibling callout on every SA product page so
 * Google sees a tight internal-link cluster around "San Antonio" + product.
 */
export interface SaSibling {
  to: string;
  label: string;
  blurb: string;
}

export const SA_SIBLINGS: SaSibling[] = [
  {
    to: "/patio-covers/in/san-antonio",
    label: "Patio Covers in San Antonio",
    blurb: "Custom welded patio covers — attached, freestanding, gable & flat designs.",
  },
  {
    to: "/aluminum-patio-covers/in/san-antonio",
    label: "Aluminum Patio Covers in San Antonio",
    blurb: "Welded aluminum frames — no rust, no rot, 20+ year lifespan.",
  },
  {
    to: "/insulated-patio-covers/in/san-antonio",
    label: "Insulated Patio Covers in San Antonio",
    blurb: "Snap-N-Lock style insulated roof panels for true heat blocking.",
  },
  {
    to: "/louvered-patio-covers/in/san-antonio",
    label: "Louvered Patio Covers in San Antonio",
    blurb: "Adjustable louvered roofs that open, close and shed rain on command.",
  },
  {
    to: "/patio-enclosures/in/san-antonio",
    label: "Patio Enclosures in San Antonio",
    blurb: "Drop curtains, wind walls and screened enclosures for year-round patios.",
  },
];
